import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({
  secondary: {
    fontStyle: 'italic',
    lineHeight: 1,
    fontSize: '0.8rem'
  },
  progress: {
    color: `${theme.palette.success.main}`,
    cursor: 'pointer'
  },
  progressDelete: {
    color: `${theme.palette.success.main}`,
    cursor: 'pointer'
  },
  submitted: {
    color: `${theme.palette.text.primary}`
  },
  lock: {
    marginBottom: 5
  },
  dialog: {
    position: 'absolute',
    left: 10,
    top: 50
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px'
  },
  radioLabel: {
    fontSize: '1rem',
    marginBottom: '0px'
  },
  label: {
    fontSize: '1rem'
  },
  timePicker: {},
  inputBase: {
    color: `${theme.palette.text.default}`,
    fontWeight: 500,
    backgroundColor: `${theme.palette.background.paper}`,
    borderRadius: '3px',
    paddingLeft: '5px',
    '&&:disabled': {
      color: 'grey'
    },
    '&::before': {
      content: '',
      display: 'none',
      borderBottom: 0
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  button: {
    height: '35px',
    lineHeight: '1rem'
  }
}));